/**
 * @file 存储取还车城市/取还车门店信息/取还车时间
 */

const weekday = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

// 城市默认给北京
const defaultState = {
    gaiCityInfo: {
        cityName: '北京',
        coordinatePoint: '116.405285,39.904989',
        cityId: 1
    },
    getCityInfo: {
        cityName: '北京',
        coordinatePoint: '116.405285,39.904989',
        cityId: 1
    },
    gaiStoreInfo: {
        storeId: '',
        storeName: ''
    },
    getStoreInfo: {
        storeId: '',
        storeName: ''
    },
    startTime: {
        year: initDate().now.getFullYear(),
        month: initDate().now.getMonth() + 1,
        day: initDate().now.getDate(),
        week: weekday[initDate().now.getDay()],
        hours: initDate().now.getHours(),
        minutes: initDate().now.getMinutes()
    },
    endTime: {
        year: initDate().tomorrow.getFullYear(),
        month: initDate().tomorrow.getMonth() + 1,
        day: initDate().tomorrow.getDate(),
        week: weekday[initDate().tomorrow.getDay()],
        hours: initDate().tomorrow.getHours(),
        minutes: initDate().tomorrow.getMinutes()
    }
};

function initDate() {
    let nowBase = Date.now() + 2 * 60 * 60 * 1000;
    let nextBase = nowBase + 2 * 8.64e7;

    let nowD = new Date(nowBase);
    let nextD = new Date(nextBase);
    if (nextD.getMinutes() % 30 !== 0) {
        nowD = new Date(nowBase + (30 - nowD.getMinutes() % 30) * 60 * 1000);
        nextD = new Date(nextBase + (30 - nextD.getMinutes() % 30) * 60 * 1000);
    }
    else if (nextD.getMinutes() % 30 === 0) {
        nowD = new Date(nowBase + 30 * 60 * 1000);
        nextD = new Date(nextBase + 30 * 60 * 1000);
    }
    return {
        now: nowD,
        tomorrow: nextD
    };
}

export default function loading(state = defaultState, action) {
    let stateCopy = {...state};
    switch (action.type) {
        // 取车城市信息
        case 'SAVE_CITY_GAI_INFO':
            const gaiCityInfoObj = Object.assign(state, action.data);
            stateCopy.gaiCityInfo = gaiCityInfoObj.gaiCityInfo;
            sessionStorage.setItem('gaiCityInfo', JSON.stringify(stateCopy.gaiCityInfo));
            break;
        // 还车城市信息
        case 'SAVE_CITY_GET_INFO':
            const getCityInfoObj = Object.assign(state, action.data);
            stateCopy.getCityInfo = getCityInfoObj.getCityInfo;
            sessionStorage.setItem('getCityInfo', JSON.stringify(stateCopy.getCityInfo));
            break;
        // 取车门店信息
        case 'SAVE_STORE_GAI_INFO':
            const gaiStoreInfoObj = Object.assign(state, action.data);
            stateCopy.gaiStoreInfo = gaiStoreInfoObj.gaiStoreInfo;
            sessionStorage.setItem('gaiStoreInfo', JSON.stringify(stateCopy.gaiStoreInfo));
            break;
        // 还车门店信息
        case 'SAVE_STORE_GET_INFO':
            const getStoreInfoObj = Object.assign(state, action.data);
            stateCopy.getStoreInfo = getStoreInfoObj.getStoreInfo;
            sessionStorage.setItem('getStoreInfo', JSON.stringify(stateCopy.getStoreInfo));
            break;
        case 'SAVE_START_TIME':
            const startTimeObj = Object.assign(state, action.data);
            stateCopy.startTime = startTimeObj.startTime;
            sessionStorage.setItem('startTime', JSON.stringify(startTimeObj.startTime));
            break;
        case 'SAVE_END_TIME':
            const endTimeObj = Object.assign(state, action.data);
            stateCopy.endTime = endTimeObj.endTime;
            sessionStorage.setItem('endTime', JSON.stringify(endTimeObj.endTime));
            break;
        default:
            return state;
    }
    return stateCopy;
}
